var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.returnGlobalDynamics),attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view',{key:_vm.currentKey})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }